<template>
  <div class="official-room-manage">
    <div class="header-process">
      <span>用户rid:</span>
      <el-input v-model="searchData.rid" placeholder="用户rid" style="width: 200px;"></el-input>
      <span>开播状态:</span>
      <el-select v-model="searchData.ownStatus" placeholder="请选择">
        <el-option v-for="item in officialType" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" @click="getOfficialList">查询</el-button>
      <el-button type="success" @click="addOfficialHandle">新增</el-button>
    </div>
    <el-table :data="roomList" height="700" style="width: 100%;">
      <el-table-column prop="rid" label="账号id"></el-table-column>
      <el-table-column prop="name" label="账号昵称"></el-table-column>
      <el-table-column prop="roomName" label="房间标题"></el-table-column>
      <el-table-column prop="roomCover" label="房间封面">
        <template slot-scope="scope">
          <img :src="scope.row.roomCover" alt="" style="width: 50px;">
        </template>
      </el-table-column>
      <el-table-column prop="valid" label="是否开播">
        <template slot-scope="scope">
          {{ scope.row.valid === 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column prop="top" label="是否顶置">
        <template slot-scope="scope">
          {{ scope.row.top === 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column prop="roomHeatValue" label="增加热度值"></el-table-column>
      <el-table-column prop="createDate" label="创建时间"></el-table-column>
      <el-table-column prop="fixDate" label="操作时间"></el-table-column>
      <el-table-column prop="chapterStartDate" label="开播开始时间"></el-table-column>
      <el-table-column prop="chapterEndDate" label="开播结束时间"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="updateDialogShow(scope.row)">更新</el-button>
          <el-button type="danger" size="mini" @click="deleteOfficialRoom(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="直播间修改" :visible.sync="updateData.visible" width="650px" :before-close="handleDialogClose">
      <div class="dialog-update">
        <div>
          <span>开播时间</span>
          <el-date-picker v-model="updateData.data.timeRange" type="datetimerange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" >
          </el-date-picker>
        </div>
        <div>
          <span>昵称</span>
          <el-input v-model="updateData.data.name" style="width: 200px;"></el-input>
          <span>国家</span>
          <el-select v-model="updateData.data.countryCode" placeholder="请选择">
            <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country" :value="item.countryCode">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>房间封面</span>
          <UploadSingleImg v-model="updateData.data.roomCover" :on-upload="upLoadImg" />
        </div>
        <div>
          <span>热度值</span>
          <el-input v-model="updateData.data.roomHeatValue" style="width: 200px;"></el-input>
          <span>房间标题</span>
          <el-input v-model="updateData.data.roomName" style="width: 200px;"></el-input>
        </div>

        <div>
          <span>签名</span>
          <el-input v-model="updateData.data.signature" style="width: 200px;"></el-input>
        </div>
        <div>
          <span>是否置顶</span>
          <el-switch v-model="updateData.data.top" active-text="是" inactive-text="否" :active-value="1"
            :inactive-value="0">
          </el-switch>
          <span>状态</span>
          <el-switch v-model="updateData.data.valid" active-text="开播" inactive-text="关播" :active-value="1"
            :inactive-value="0">
          </el-switch>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="updateInfoSubmit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getOfficialRoomList, createOfficialRoom, updateOfficialRoomList } from '@/api/officialRoomRequest.js'
import UploadSingleImg from '../UploadSingleImg/UploadSingleImg'
export default {
  components: {
    UploadSingleImg
  },
  data() {
    return {
      // 官方直播间状态
      officialType: [
        { value: null, label: '全部' },
        { value: 1, label: '开播' },
        { value: 0, label: '关播' },
      ],
      countryList: [],
      roomList: [],
      searchData: {
        rid: null,
        ownStatus: null
      },
      updateData: {
        visible: false,
        data: {
          timeRange: []
        }
      }
    }
  },
  mounted() {
    this.getOfficialList()
    this.getCountryList()
  },
  methods: {
    async getCountryList() {
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.CountryList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      )
      this.countryList = res.data.countryList
    },
    reqMessageShow(res) {
      if (res.code === 0) {
        this.$message({ type: 'success', message: "操作成功" })
        this.getOfficialList()
      } else {
        this.$message({ type: 'warning', message: res.msg })
      }
    },
    // 上传图片接口
    async upLoadImg(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('cover', 0)
      formData.append('dir', 'room_cover/icon/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      return { code: res.code, url: res.data }
    },
    // 获取官方直播间列表
    async getOfficialList() {
      const res = await getOfficialRoomList(this.searchData)
      if (res.code === 0) {
        this.roomList = res.data
        this.$message({ type: 'success', message: "查询成功" })
      } else {
        this.$message.error(res.msg)
        this.roomList = []
      }
    },
    // 添加官方直播间
    addOfficialHandle() {
      this.$prompt('用户rid', '新增', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        const res = await createOfficialRoom({ ridList: value })
        this.reqMessageShow(res)
      }).catch(() => {

      });
    },
    // 删除官方直播间
    deleteOfficialRoom(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await updateOfficialRoomList({ roomId: row.roomId, uid: row.uid, officialRoom: 0 })
        this.reqMessageShow(res)
      }).catch(() => {

      });
    },
    // 更新弹窗显示
    updateDialogShow(row) {
      this.updateData.data = JSON.parse(JSON.stringify(row))
      if(row.chapterStartDate && row.chapterEndDate){
        this.$set(this.updateData.data, 'timeRange', [row.chapterStartDate, row.chapterEndDate])
      }
      this.updateData.visible = true
      console.log(this.updateData.data);

    },
    // 更新弹窗关闭事件
    handleDialogClose() {
      this.updateData.visible = false
    },
    // 更新弹窗提交
    async updateInfoSubmit() {
      if (this.updateData.data.timeRange && this.updateData.data.timeRange.length === 2) {
        this.$set(this.updateData.data, 'chapterStartDate', this.updateData.data.timeRange[0] + '.000')
        this.$set(this.updateData.data, 'chapterEndDate', this.updateData.data.timeRange[1] + '.000')
      }
      console.log(this.updateData.data);
      const res = await updateOfficialRoomList(this.updateData.data)
      this.reqMessageShow(res)
      this.updateData.visible = false
    }
  }
}
</script>
<style scoped lang="scss">
.official-room-manage {
  .header-process {
    display: flex;
    align-items: center;

    span {
      margin: 0 20px;
    }

    .el-select {
      margin-right: 20px;
    }
  }

}


.dialog-update {
  &>div {
    margin: 10px 0;

    &>span {
      display: inline-block;
      width: 70px;
      text-align: center;
    }
  }

}
</style>